var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-aside-cart-container" }, [
    _c("div", { staticClass: "product-aside-cart-item" }, [
      _c(
        "form",
        {
          staticClass: "product-aside-personalise-form-inline",
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.isB2B
            ? _c("div", [
                _c("span", [
                  _vm._v(
                    "Recipient name: " + _vm._s(_vm.b2bCart.recipientName)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isB2B && _vm.b2bMultiPersonalisation
            ? _c("div", [
                _vm.feature.B2B.autofill_personalisation
                  ? _c("div", { staticClass: "form-input" }, [
                      _c(
                        "div",
                        {
                          class: _vm.dropdownCss(),
                          on: { click: _vm.toggleB2BDropdown },
                        },
                        [
                          _c(
                            "ul",
                            {
                              attrs: {
                                "data-test": "product-variant-dropdown",
                              },
                            },
                            [
                              _c("li", { staticClass: "selected" }, [
                                _vm._v("Select option"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "variant-dropdown",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setB2BDropdown("name")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.b2bCart.recipientName) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.b2bCompany.companyName
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "variant-dropdown",
                                      on: {
                                        click: function ($event) {
                                          return _vm.setB2BDropdown("company")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.b2bCompany.companyName) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "variant-dropdown",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setB2BDropdown("custom")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Custom message\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.feature.B2B.autofill_personalisation &&
                _vm.b2bDropdown.selected !== ""
                  ? _c("div", { staticClass: "form-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.message,
                            expression: "message",
                          },
                        ],
                        ref: "input",
                        staticClass: "sensitive",
                        attrs: {
                          autofocus: "",
                          disabled: _vm.adding,
                          id: "personalisation-input",
                          placeholder: "personalised message",
                          maxlength: _vm.max_message_length,
                          type: "text",
                        },
                        domProps: { value: _vm.message },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.message = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class:
                            _vm.charCount > _vm.max_message_length
                              ? "count-over"
                              : "count",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.charCount) +
                              "/" +
                              _vm._s(_vm.max_message_length)
                          ),
                        ]
                      ),
                    ])
                  : _c("div", { staticClass: "form-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.message,
                            expression: "message",
                          },
                        ],
                        ref: "input",
                        staticClass: "sensitive",
                        attrs: {
                          autofocus: "",
                          disabled: _vm.adding,
                          id: "personalisation-input",
                          placeholder: "personalised message",
                          maxlength: _vm.max_message_length,
                          type: "text",
                        },
                        domProps: { value: _vm.message },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.message = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class:
                            _vm.charCount > _vm.max_message_length
                              ? "count-over"
                              : "count",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.charCount) +
                              "/" +
                              _vm._s(_vm.max_message_length)
                          ),
                        ]
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isB2B && _vm.b2bMultiPersonalisation
            ? _c("div", { staticClass: "form-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  ref: "input",
                  staticClass: "sensitive",
                  attrs: {
                    autofocus: "",
                    disabled: _vm.adding,
                    id: "personalisation-input",
                    placeholder: "personalised message",
                    maxlength: _vm.max_message_length,
                    type: "text",
                  },
                  domProps: { value: _vm.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.message = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class:
                      _vm.charCount > _vm.max_message_length
                        ? "count-over"
                        : "count",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.charCount) +
                        "/" +
                        _vm._s(_vm.max_message_length)
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.b2bMultiPersonalisation
            ? _c("div", { staticClass: "form-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message",
                    },
                  ],
                  ref: "input",
                  staticClass: "sensitive",
                  attrs: {
                    autofocus: "",
                    disabled: _vm.adding,
                    id: "personalisation-input",
                    placeholder: "personalised message",
                    maxlength: _vm.max_message_length,
                    type: "text",
                  },
                  domProps: { value: _vm.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.message = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class:
                      _vm.charCount > _vm.max_message_length
                        ? "count-over"
                        : "count",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.charCount) +
                        "/" +
                        _vm._s(_vm.max_message_length)
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              class: _vm.buttonAddClass,
              staticStyle: { width: "100%" },
              attrs: { type: "button", disabled: _vm.isSubmitDisabled },
              on: { click: _vm.addToCart },
            },
            [_vm._v("Add to cart")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }